import FindAContractorListing from '../FindAContractor/Listing';
import { withRailsContext } from '../RailsContext';

export default withRailsContext(FindAContractorListing);
